import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ImpactForecasting from '../pages/ImpactForecasting';

const Home = lazy(() => import('../pages/Home'));
const ImpactFrameworkOverview = lazy(() => import('../pages/ImpactFrameworkOverview'));
const MeasurementMEL = lazy(() => import('../pages/MeasurementMEL'));
const ImpactAssessmentProjects = lazy(() => import('../pages/ImpactAssessmentProjects'));
const ContactAbout = lazy(() => import('../pages/ContactAbout'));
const ProgramImpact = lazy(() => import('../pages/ProgramImpact'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const Terms = lazy(() => import('../pages/Terms'));
const Changelog = lazy(() => import('../pages/Changelog'));
const UserGuide = lazy(() => import('../pages/UserGuide'));

const CoastalFisheryPolicyGovernance = lazy(() => import('../pages/resilience/CoastalFisheryPolicyGovernance'));
const CoastalFisheryCoManagement = lazy(() => import('../pages/resilience/CoastalFisheryCoManagement'));
const AdaptiveCapacityClimateChange = lazy(() => import('../pages/resilience/AdaptiveCapacityClimateChange'));
const CapacityCollectiveAction = lazy(() => import('../pages/resilience/CapacityCollectiveAction'));
const SustainableLivelihoods = lazy(() => import('../pages/resilience/SustainableLivelihoods'));
const CoastalBiodiversityEcosystemServices = lazy(() => import('../pages/resilience/CoastalBiodiversityEcosystemServices'));

const ImelPlanList = lazy(() => import('../pages/imel/ImelPlanList'));
const ImelPlanWizard = lazy(() => import('../pages/imel/ImelPlanWizard'));

const AppRoutes = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/overview" element={<ImpactFrameworkOverview />} />
      <Route path="/measurement-mel" element={<MeasurementMEL />} />
      <Route path="/impact-projects" element={<ImpactAssessmentProjects />} />
      <Route path="/program-impact" element={<ProgramImpact />} />
      <Route path="/contact" element={<ContactAbout />} />
      <Route path="/impact-forecasting" element={<ImpactForecasting />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route path="/user-guide" element={<UserGuide />} />
      {/* Resilience Factor Pages */}
      <Route path="/resilience/coastal-fishery-policy-governance" element={<CoastalFisheryPolicyGovernance />} />
      <Route path="/resilience/coastal-fishery-co-management" element={<CoastalFisheryCoManagement />} />
      <Route path="/resilience/adaptive-capacity-climate-change" element={<AdaptiveCapacityClimateChange />} />
      <Route path="/resilience/capacity-collective-action" element={<CapacityCollectiveAction />} />
      <Route path="/resilience/sustainable-livelihoods" element={<SustainableLivelihoods />} />
      <Route path="/resilience/coastal-biodiversity-ecosystem-services" element={<CoastalBiodiversityEcosystemServices />} />
      {/* IMEL Plan Builder */}
      <Route path="/imel-plan-builder" element={<ImelPlanList />} />
      <Route path="/imel-plan-builder/:planId" element={<ImelPlanWizard />} />
    </Routes>
  </Suspense>
);

export default AppRoutes; 